import { Component, Output, Input, EventEmitter, OnChanges } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { DayMonth } from '@documalis/_const/const';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { formatDateInt } from '@core/_utils/date.utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-form-delegate',
    templateUrl: './form-delegate.component.html',
    styleUrls: ['./form-delegate.component.scss'],
    providers: [AutofocusDirective],
})
export class FormDelegateComponent extends FormBase implements OnChanges {
    public resultForm: FormGroup;
    public validClick = false;
    public listVisibility = [];
    public visibility = 0;
    public isAdmin = false;
    public firstDayOfWeek: number;

    public useDelegate = false;

    @Input()
    public add: boolean = false;
    
    @Input()
    public delegate: any;

    @Input()
    public fromUser = [];

    @Input()
    public toUser = [];


    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();


    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        if (this.add === false) {
            this.resultForm = this.formBuilder.group({
                id: null,
                useDelegate: false,
                dateBegin: [new Date(), [Validators.required]],
                dateEnd: [new Date(), [Validators.required]],
                fromLogin: [null, [Validators.required]],
                delegatedLogin: [null, [Validators.required]],
            });
        } else {
            this.resultForm = this.formBuilder.group({
                id: null,
                useDelegate: false,
                dateBegin: [new Date(), [Validators.required]],
                dateEnd: [new Date(), [Validators.required]],
                fromLogin: [null],
                delegatedLogin: [null, [Validators.required]],
            });

        }
        this.initialization();
        this.firstDayOfWeek = DayMonth.firstDayOfWeek;
    }

    ngOnChanges() {
        if (this.delegate) {
            this.resultForm.patchValue(this.delegate);
            if (this.add === false )
                this.resultForm.get('fromLogin').disable();
        }
    }

    public onChangeVisibility($event) {
        this.visibility = $event.value;
    }

    public validate() {
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            if (this.verifyData() === true) {
                this.execValidate();
            }
        }
    }

    private verifyData() {
        if (this.verifyUser() === false || this.verifyDate() === false) {
            return false;
        } else {
            return true;
        }
    }

    private verifyDate() {
        let wDateNow: Date;
        let wDateBegin: Date;
        // let wDateEnd: Date;
        wDateNow = new Date();
        if (this.add === true) {
            wDateBegin = new Date(formatDateInt(new Date(this.resultForm.value.dateBegin), true));
            if (wDateBegin < wDateNow) {
                this.messageService.addWarnNoStick(this.translate.instant('Date_KO_1'));
                return false;
            }
        }
        if ( new Date(this.resultForm.value.dateBegin) > new Date(this.resultForm.value.dateEnd)) {
            this.messageService.addWarnNoStick(this.translate.instant('Date_KO_2'));
            return false;
        }
        return true;
    }

    private verifyUser() {
        if (this.resultForm.value.fromLogin === this.resultForm.value.delegatedLogin) {
            this.messageService.addWarnNoStick(this.translate.instant('Delegate_1'));
            return false;
        } else {
            return true;
        }
    }

    private execValidate() {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            entete: this.resultForm.getRawValue(),
        };
        this.validClick = true;
        this.onValidate.emit(wRequest);
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    private initialization() {
        this.keys = {
            fromLogin: {
                label: this.translate.instant('Delegate_1'),
                pattern: '',
            },
            delegatedLogin: {
                label: this.translate.instant('Delegate_1'),
                pattern: '',
            },
            dateBegin: {
                label: this.translate.instant('Date_Beg'),
                pattern: '',
            },
            dateEnd: {
                label: this.translate.instant('Date_End'),
                pattern: '',
            },
        };
    }
}
